import AbstractRepository from "@/repositories/AbstractRepository";

export default class OwnerReportRepository extends AbstractRepository {
    protected static resource: string = "ownerreport";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "type",
        "icon",
        "enabled",
        "module",
        "reportUuid",
        "linkReports",
        "agentAiAccess"
    ];
}
